import { render } from "./RouteNotFound.vue?vue&type=template&id=6ad7b2cc&scoped=true"
const script = {}

import "./RouteNotFound.vue?vue&type=style&index=0&id=6ad7b2cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad7b2cc"]])

export default __exports__